import { Navigate, NavLink, Outlet } from 'react-router';
import { Splash, Wordmark } from '../../components/AppShell';
import { BackIcon } from '../../components/icons';
import { useMe } from '../../lib/queries';

export const ADMIN_SECTIONS: { to: string; label: string }[] = [
  { to: '/admin', label: 'Overview' },
  { to: '/admin/sources', label: 'Sources' },
  { to: '/admin/import', label: 'Import' },
  { to: '/admin/generator', label: 'Generator' },
  { to: '/admin/pool', label: 'Pool' },
  { to: '/admin/costs', label: 'API and costs' },
  { to: '/admin/batch', label: 'Batch jobs' },
  { to: '/admin/needs-plugin', label: 'Needs a plugin' },
  { to: '/admin/solver', label: 'Solver report' },
  { to: '/admin/health', label: 'Health' },
  { to: '/admin/library', label: 'Library tools' },
];

/** Admin: desktop-first, only for the admin role. Everyone else goes home. */
export function AdminLayout() {
  const me = useMe();
  if (me.isPending) return <Splash />;
  if (me.isError) return <Splash message="ZincSudoku can't reach the server. Try again shortly." />;
  if (me.data.user.role !== 'admin') return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-dvh flex-col lg:flex-row">
      <nav
        aria-label="Admin"
        className="box-border flex shrink-0 flex-row flex-wrap gap-1 border-b border-line bg-surface px-3 py-3 lg:sticky lg:top-0 lg:h-dvh lg:w-[232px] lg:flex-col lg:flex-nowrap lg:overflow-y-auto lg:border-r lg:border-b-0 lg:py-[18px]"
      >
        <div className="flex items-center gap-2 px-2 pb-1 lg:pb-3.5">
          <Wordmark />
          <span className="inline-flex h-[22px] items-center rounded-[6px] bg-ink px-2 text-[11px] font-bold text-white">
            Admin
          </span>
        </div>
        {ADMIN_SECTIONS.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            end
            className={({ isActive }) =>
              `flex h-10 shrink-0 items-center rounded-[9px] px-3 text-[14px] no-underline ${
                isActive ? 'bg-accent-tint font-bold text-accent-dark' : 'font-medium text-ink'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
        <NavLink
          to="/"
          className="flex h-10 shrink-0 items-center gap-2 rounded-[9px] px-3 text-[14px] font-medium text-subtle no-underline lg:mt-auto"
        >
          <BackIcon size={16} />
          Back to the app
        </NavLink>
      </nav>
      <main className="box-border flex min-w-0 flex-1 flex-col gap-4 px-4 py-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
}
